export const colors = {
  accentColor: "#e88f23",
  secondColor: "#F0F0E9",
  gray: "#828181",
  lightGray: "#b3b1b1",
  lightBlack: "#2e2d2d",
  black: "black",
  limeGreen: "#9de848",
  lightRed: "#f23f35",
  red: "red",
  white: "white",
  dirtyWhite: "#fafdff",
};

export const fontWeight = {
  light: "100",
  medium: "400",
  mediumBold: "600",
  bold: "800",
};

export const fontSize = {
  xSmall: "10px",
  small: "12px",
  optimal: "13px",
  smallPlus: "14px",
  normal: "16px",
  medium: "18px",
  large: "24px",
  xLarge: "36px",
};

export const fontFamily = {
  LatoBlack: "LatoBlack",
  LatoBlackItalic: "LatoBlackItalic",
  LatoBold: "LatoBold",
  LatoBoldItalic: "LatoBoldItalic",
  LatoItalic: "LatoItalic",
  LatoLight: "LatoLight",
  LatoLightItalic: "LatoLightItalic",
  LatoRegular: "LatoRegular",
  LatoThin: "LatoThin",
  LatoThinItalic: "LatoThinItalic",
  MontserratBlack: "MontserratBlack",
  MontserratBlackItalic: "MontserratBlackItalic",
  MontserratBold: "MontserratBold",
  MontserratBoldItalic: "MontserratBoldItalic",
  MontserratExtraBold: "MontserratExtraBold",
  MontserratExtraLight: "MontserratExtraLight",
};
